<div>
    <div class="modal-header w-100">
        <div class="row w-100">
            <div class="col-md-6" [ngSwitch]="calculationType">
                <div *ngSwitchCase="0">
                    <h4>{{ 'PLANT_MANAGER.STANDARD_FLANGE' | transloco }}</h4>
                </div>
                <div *ngSwitchCase="1">
                    <h4>{{ 'PLANT_MANAGER.CUSTOM_FLANGE' | transloco }}</h4>
                </div>
                <div *ngSwitchCase="2">
                    <h4>{{ 'PLANT_MANAGER.CLAMP' | transloco }}</h4>
                </div>
                <div *ngSwitchCase="3">
                    <h4>{{ 'PLANT_MANAGER.ENGINEERED_JOINT' | transloco }}</h4>
                </div>
                <div *ngSwitchDefault>DEFAULT: {{ calculationType }}</div>
            </div>
            <div class="col-md-6">
                <div class="code_details_title">
                    <div class="title-wrap" *ngIf="taggedItem?.taggedItemId">
                        <h4>
                            <span class="UniqueId">{{ taggedItem?.taggedItemId ? taggedItem?.namePrimary : '' }}</span>
                        </h4>
                    </div>
                    <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="closeClick()"><i class="flaticon2-cross"></i> </a>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-body output-lable activity_body" style="max-height: calc(100vh - 255px); overflow: auto">
        <div class="card card-custom gutter-b card-stretch" style="width: 100%">
            <div class="_card-body card-body">
                <mat-tab-group class="tab-wrapper">
                    <!-- <mat-tab label="Diagrams"> -->

                    <mat-tab label="Calculation">
                        <div class="row calculationDiv">
                            <div class="col-xl-12">
                                <div class="row gx-5">
                                    <div class="col-xl-6 col-lg-6 col-md-6">
                                        <div class="group">
                                            <div class="group-title">{{ 'PLANT_MANAGER.General' | transloco }}</div>
                                            <div class="inner-group">
                                                <app-pipe-code-general [calcType]="calculationType" class="calculation-component"></app-pipe-code-general>
                                            </div>
                                        </div>

                                        <div class="group">
                                            <div class="group-title">{{ 'PLANT_MANAGER.ControlTightiningProcedure' | transloco }}</div>
                                            <div class="inner-group">
                                                <app-tightening-procedure-input
                                                    [calculationType]="calculationType"
                                                    [isRedirect]="isRedirect"
                                                    (returnData)="tighteningDataHandler($event)"
                                                    (diagram)="diagramDataHandler($event)"
                                                ></app-tightening-procedure-input>
                                            </div>
                                        </div>

                                        <div class="group" *ngIf="calculationType == 0 || calculationType == 1">
                                            <div class="group-title">{{ 'PLANT_MANAGER.ProcessInformation' | transloco }}</div>
                                            <div class="inner-group">
                                                <app-process-information-input
                                                    [isRedirect]="isRedirect"
                                                    [processInfoInput]="processInfoInput"
                                                    (returnData)="processInfoDataHandler($event)"
                                                ></app-process-information-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6">
                                        <div class="group standard-flange-warp">
                                            <div *ngIf="calculationType == 0">
                                                <div class="group-title">
                                                    {{ 'PLANT_MANAGER.STANDARD_FLANGE' | transloco }}
                                                </div>
                                                <div class="inner-group">
                                                    <app-flange-input
                                                        [isRedirect]="isRedirect"
                                                        [calculationType]="calculationType"
                                                        (returnData)="StdDataHandler($event)"
                                                        (diagram)="diagramDataHandler($event)"
                                                        (isEditable)="isEditableDataHandler($event)"
                                                        (processInfo)="processInfoInputDataHandler($event)"
                                                        (isOverriddenFlange)="overriddenFlangeHandler($event)"
                                                    ></app-flange-input>
                                                </div>
                                            </div>
                                            <div *ngIf="calculationType == 1">
                                                <div class="group-title">
                                                    {{ 'PLANT_MANAGER.CUSTOM_FLANGE' | transloco }}
                                                </div>
                                                <div class="inner-group">
                                                    <app-custom-flange-input
                                                        [isRedirect]="isRedirect"
                                                        [calculationType]="calculationType"
                                                        (returnData)="customFlangeDataHandler($event)"
                                                        (diagram)="diagramDataHandler($event)"
                                                    ></app-custom-flange-input>
                                                </div>
                                            </div>
                                            <div *ngIf="calculationType == 2">
                                                <div class="group-title">
                                                    {{ 'PLANT_MANAGER.CLAMP' | transloco }}
                                                </div>
                                                <div class="inner-group">
                                                    <app-clamp-input
                                                        [isRedirect]="isRedirect"
                                                        [calculationType]="calculationType"
                                                        (returnData)="InputsDataHandler($event)"
                                                        (diagram)="diagramDataHandler($event)"
                                                    ></app-clamp-input>
                                                </div>
                                            </div>
                                            <div *ngIf="calculationType == 3">
                                                <div class="group-title">
                                                    {{ 'PLANT_MANAGER.ENGINEERED_JOINT' | transloco }}
                                                </div>
                                                <div class="inner-group">
                                                    <app-engineered-joint-input
                                                        [isRedirect]="isRedirect"
                                                        [calculationType]="calculationType"
                                                        (returnData)="engJointDataHandler($event)"
                                                        (diagram)="diagramDataHandler($event)"
                                                    ></app-engineered-joint-input>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- </div> -->
                    </mat-tab>

                    <mat-tab label="Diagrams">
                        <div style="width: 100%">
                            <app-diagrams
                                [isRedirect]="isRedirect"
                                [diagramInfo]="diagramInfo"
                                [calcOutput]="calculationResult"
                                (diagram)="diagramDataHandler($event)"
                                (CalcOverrides)="diagramControlDataHandler($event)"
                                style="width: 100%"
                                [calculationType]="calculationType"
                            ></app-diagrams>
                        </div>
                    </mat-tab>
                    <!-- <mat-tab label="Calculation Outputs"> -->
                </mat-tab-group>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn secondary-ebtn" (click)="closeClick()">{{ 'PLANT_MANAGER.Cancel' | transloco }}</button>
        <button type="button" class="btn primary-ebtn" (click)="btnCalculateClicked()" [disabled]="disableButton()">
            {{ 'PLANT_MANAGER.Calculate' | transloco }}
        </button>
    </div>
</div>
